import { disableSetBodyScroll } from '@/utils/utils';
import { envRegion } from '../constants';
interface SsosdkObj {
  render: Function;
}

let ssosdk: SsosdkObj;
let AccountSecondVerifySDK: any;
async function init(options: any) {
  AccountSecondVerifySDK = (
    await import(
      /* webpackChunkName: "asv" */
      /* webpackMode: "lazy" */
      /* 此处引入的是二次验证的仓库代码 https://code.byted.org/secsdk/second-valid-web */
      process.env.ASV_NPM_NAME as string
    )
  ).default;
}

export const secondVerifyWebShow = async (options: any) => {
  // if (ssosdk) {
  //   ssosdk.show(options);
  // } else {
  //   await init(options);
  //   // @ts-ignore
  //   ssosdk.show(options);
  // }
  if (!ssosdk) {
    await init(options);
  }
  // console.log('second verify options', options);
  ssosdk = new AccountSecondVerifySDK(options);
  if (options.disableScroll) {
    const recover = disableSetBodyScroll();
    const closeCallBack = options.closeCallBack;
    options.closeCallBack = () => {
      recover();
      closeCallBack?.();
    };
  }
  // @ts-ignore
  ssosdk.render();
};
